import { styled } from "@mui/material/styles";
import Box from "@mui/system/Box";
import Tabs from "@mui/material/Tabs";
import Tab from "@mui/material/Tab";

export const StyledBox = styled(Box)(({ theme }) => ({
  backgroundColor: theme.palette.background.paper,
  paddingTop: "6rem",
  maxWidth: "100%",
}));

export const StyledTabs = styled(Tabs)(({ theme }) => ({
  borderBottom: `1px solid ${theme.palette.divider}`,
  "& .MuiTabs-indicator": {
    backgroundColor: theme.palette.primary.main,
  },
}));

export const StyledTab = styled(Tab)(({ theme }) => ({
  textTransform: "none",
  fontSize: "16px",
  fontFamily: "TisaSansPro",
  "&.Mui-selected": {
    color: theme.palette.primary.main,
  },
}));

export const StyledTooltip = styled(Tab)(({ theme }) => ({

}));



